import { adminHttpClient } from '../../commons/adminHttpClient'
import localStorage from '../../commons/localStorage'
import { NamedItem } from '../../../domain/common/namedItem'

export interface State {
  prospectInfo: ProspectInfo
  insuranceBrokerInfo: ProspectInsuranceBrokerInfoValues | null
  applicationInfo: ApplicationInfo
  plans: Plan[]
}

export interface ProspectInfo {
  companyName: string
  firstName: string
  lastName: string
  email: string
  jobTitle: string
  secondaryEmails: string[]
}

export interface ProspectInsuranceBrokerInfoValues {
  hasInsuranceBroker: boolean | null
  brokerFirstName: string
  brokerLastName: string
  brokerEmail: string
  sendAnalysisToBroker: boolean | null
}

export interface ApplicationInfo {
  currentPlanStatus: number
  currentPlanStatusOptions: NamedItem[]
  whyConsiderAlternatives: number[]
  whyConsiderAlternativesOther: string
  whyConsiderAlternativesOptions: NamedItem[]
  powerToChooseImportance: number
  powerToChooseImportanceOptions: number[]
  coverageOptionsImportance: number
  coverageOptionsImportanceOptions: number[]
}

export interface Plan {
  id: string
  eligibleEmployeesNumber: number
  participatingEmployeesNumber: number
  carrier: string
  planMetalTier: number
  deductible: number[]
  deductibleIndividualAmount: number | null
  deductibleFamilyAmount: number | null
  maxOutOfPocket: number[]
  maxOutOfPocketIndividualAmount: number | null
  maxOutOfPocketFamilyAmount: number | null
  organizationSpendPerMonth: number
  employeeCoveragePercentage: number
  dependentsCoveragePercentage: number | null
  renewalOrStartDate: string
  rateIncrease: number | null
  budgetGoal: BudgetGoal | null

  planMetalTiersOptions: NamedItem[]
  deductibleOptions: NamedItem[]
  maxOutOfPocketOptions: NamedItem[]

  budgetGoalsOptions: NamedItem[]
  employeeContributionStrategyOptions: NamedItem[]
  availableReimbursementOptions: NamedItem[]
  employeeCategoryOptions: NamedItem[]
}

export interface BudgetGoal {
  id: string
  budgetGoal?: number
  decreaseCurrentSpendPercentage?: number
  employeeContributionStrategy?: number | null
  reimbursementOptions?: number
  offerDifferentAmount?: boolean
  offerTraditionalGroupHealthInsurance?: boolean
  employeeCategories: number[]
}

const stateApi = (): Promise<any> => {
  const code = localStorage.getProspectSignupCode()
  var encodedCode = encodeURIComponent(code ?? '')

  return adminHttpClient.get(`/IchraDecisionTool/ProspectApplication/Wizard/State?code=${encodedCode}`)
}

export default stateApi
